import React from 'react';

type IconProps = React.SVGProps<SVGSVGElement>;

const ReferIcon: React.FC<IconProps> = (props) => (
  <svg
    width="14"
    height="14"
    viewBox="0 0 14 14"
    fill="currentColor"
    xmlns="http://www.w3.org/2000/svg"
    {...props} // Spread props here to apply color, style, etc.
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M2.875 0.18515C2.67609 0.18515 2.48532 0.264168 2.34467 0.40482C2.20402 0.545472 2.125 0.736238 2.125 0.93515V1.31015H0.25V8.43515H8.5V1.31015H6.625V0.93515C6.625 0.736238 6.54598 0.545472 6.40533 0.40482C6.26468 0.264168 6.07391 0.18515 5.875 0.18515H2.875ZM5.875 4.68515C6.07391 4.68515 6.26468 4.60613 6.40533 4.46548C6.54598 4.32483 6.625 4.13406 6.625 3.93515V3.56015H7.75V7.68515H5.875V5.43515H2.875V7.68515H1V3.56015H2.125V3.93515C2.125 4.13406 2.20402 4.32483 2.34467 4.46548C2.48532 4.60613 2.67609 4.68515 2.875 4.68515H5.875ZM1 2.06015H2.125V2.81015H1V2.06015ZM7.75 2.81015H6.625V2.06015H7.75V2.81015ZM5.125 6.18515V7.68515H3.625V6.18515H5.125ZM4 0.93515V2.06015H2.875V2.81015H4V3.93515H4.75V2.81015H5.875V2.06015H4.75V0.93515H4Z"
      fill="currentColor"
    />
    <path
      d="M9.24999 8.06015C9.24999 7.66233 9.40802 7.28079 9.68933 6.99949C9.97063 6.71819 10.3522 6.56015 10.75 6.56015C11.1478 6.56015 11.5293 6.71819 11.8106 6.99949C12.092 7.28079 12.25 7.66233 12.25 8.06015C12.25 8.45797 12.092 8.83951 11.8106 9.12081C11.5293 9.40211 11.1478 9.56015 10.75 9.56015C10.3522 9.56015 9.97063 9.40211 9.68933 9.12081C9.40802 8.83951 9.24999 8.45797 9.24999 8.06015ZM10.75 10.3102C9.74874 10.3102 7.74999 10.8584 7.74999 11.9466V12.9352H4.37499C4.10161 12.9352 3.92424 12.8365 3.81136 12.7094C3.69249 12.5755 3.62499 12.3865 3.62499 12.1852V10.8404L4.85986 12.0753L5.39011 11.545L3.24999 9.4049L1.10986 11.545L1.64011 12.0753L2.87499 10.8404V12.1852C2.87499 12.5463 2.99499 12.9198 3.25111 13.2078C3.51324 13.5025 3.89836 13.6852 4.37499 13.6852H13.75V11.9466C13.75 10.8584 11.7512 10.3102 10.75 10.3102Z"
      fill="currentColor"
    />
  </svg>
);

export default ReferIcon;
